import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-457c3ed3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "arrow-icon" }
const _hoisted_4 = {
  key: 0,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fold-panel-wrap", { fold: _ctx.isFold }])
  }, [
    _createElementVNode("div", {
      class: "head",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFold = !_ctx.isFold))
    }, [
      _createElementVNode("img", {
        src: _ctx.icon,
        width: "18",
        height: "18",
        alt: ""
      }, null, 8, _hoisted_1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CmSvgIcon, {
          name: "views/dashboard/group/client/terminal-info/fold-panel/_images/arrow-up",
          monochrome: "",
          size: 16
        })
      ])
    ]),
    (!_ctx.isFold)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}